// ==========================================
// ENVIRONMENT TOGGLE
// Uncomment ONE of the environments below
// ==========================================

// ------------------------------------------
// 1. UAT ENVIRONMENT (Live Server)set NODE_OPTIONS=--max-old-space-size=4096 && npm run build
// ------------------------------------------
export const ENV = {
  baseURL: "https://api-uat.taprootcrm.com/", // 3.109.33.189
  // baseURL: "https://api-uat.rentexcel.com/", // 35.154.66.81
  isLocal: false,
};

// ------------------------------------------
// 2. LOCAL ENVIRONMENT
// ------------------------------------------
// export const ENV = {
//   baseURL: "https://api-uat.taprootcrm.com", 
//     // baseURL: "http://192.168.0.180:4567", 

//   isLocal: true,
//   localDomain: "site-exit.taprootcrm.com",
//   // localDomain: "192.168.0.180", 
// };
 
// export const ENV = {
//   baseURL: "https://api-uat.rentexcel.com",
//   isLocal: true,
//   localDomain: "medeaz.rentexcel.com",
// };
// ------------------------------------------

// Helper to determine the domain dynamically based on the selected environment
export const getDomainHeader = (uatFallbackDomain) => {
  if (ENV.isLocal) {
    return ENV.localDomain;
  }

  const hostname = window.location.hostname;
  const isLocalHost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    hostname.includes(":");
  
  if (isLocalHost) {
    const devDomain = localStorage.getItem("dev_domain");
    if (devDomain) return devDomain;
    return uatFallbackDomain;
  }
  return hostname.replace(/^www\./i, "");
};
